import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import usePlanner from "features/planner/state/usePlanner";
import useDeviceType from "hooks/useDeviceType";
import { createSimpleHandler } from "features/planner/utils/inputValidation";
import colors from "app/theme/base/colors";
import { alpha } from "@mui/material/styles";

export default function ClientNameInput() {
  const { programState, updateProgramField } = usePlanner();
  const { isLaptop } = useDeviceType();

  const inputFont = isLaptop ? "0.75rem" : "0.88rem";
  const height = isLaptop ? "38px" : "46px";
  const paddingTop = isLaptop ? "2px" : "6px";

  const isEmpty = !(programState.clientName || "").trim();

  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "10px",
        backgroundColor: isEmpty ? (theme) => alpha(theme.palette.error.main, 0.04) : "grey.100",
        border: "1px solid",
        borderColor: isEmpty ? "error.main" : "grey.300",
        px: 1.2,
        pt: paddingTop,
        pb: "6px",
        height,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        transition: "all 0.15s ease",

        "&:hover": {
          backgroundColor: isEmpty
            ? (theme) => alpha(theme.palette.error.main, 0.08)
            : (theme) => alpha(theme.palette.primary.main, 0.06),
        },
      }}
    >
      <input
        type="text"
        value={programState.clientName || ""}
        onChange={createSimpleHandler("clientName", (v) => updateProgramField("clientName", v))}
        placeholder="Nombre del cliente"
        maxLength={60}
        style={{
          flex: 1,
          border: "none",
          outline: "none",
          background: "transparent",
          fontSize: inputFont,
          fontWeight: 600,
          color: colors.text.primary,
        }}
      />
    </Box>
  );
}

ClientNameInput.propTypes = {
  label: PropTypes.string,
};
